import type { Ref } from "vue";

export function useClipboardResult(actionResult: Ref<string>, fallbackMessage: string) {
  async function copyText(text: string, message: string) {
    try {
      await navigator.clipboard.writeText(text);
      actionResult.value = message;
      return true;
    } catch {
      actionResult.value = fallbackMessage;
      return false;
    }
  }

  async function copyJson(payload: unknown, message: string) {
    return copyText(JSON.stringify(payload, null, 2), message);
  }

  return { copyJson, copyText };
}
